import React, { Component } from 'react';
import styled from 'styled-components';
import Button from '../Button/Button';
import PinterestAnalyticsTracker from './PinterestAnalyticsTracker';
import { DATA_TRACK_TYPE_CTA, DOM_PRIMARY_LINK, DOM_SECONDARY_LINK } from '../../../../lib/constants';
import {
  toSlug,
  trackAnalytics,
  trackAnalyticsNew,
  resolveAccessibleLabel,
} from '../../../../lib/utils';
import ShopNowButton from '../Button/ShopNowButton';

// *** Hover State ***
const HoverState = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${(p) => p.theme.elevation[0]};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${(p) => p.theme.c.bg.primary};
    opacity: 0.75;
    pointer-events: none;
    z-index: 0;
  }
  button, a {
    margin: ${(p) => p.theme.unit(0.4)};
  }
`;

const ButtonsContainer = styled.div`
  position: relative;
  z-index: 1;
`;

class CardHoverState extends Component {

  render() {

    const {
      primaryLink,
      secondaryLink,
      primaryText,
      primaryButtonTagSet,
      secondaryText,
      secondaryButtonTagSet,
      parentId,
      shop,
      offer = {},
      shopSlug,
      offerSlug,
      dataLayerId,
      dataContextContainer,
      makeAndOpenModal,
      pageStateModifiers,
      imageTitleTag,
      locale,
      idPrefix,
      defaultOnClickHandler,
      secondaryBehaviour = 'anchor',
      trackingLocation,
      primaryTrackingName,
      secondaryTrackingName,
    } = this.props;

    const { linkTextPrepositions } = shop;
    const { descriptiveText, prepositionKey, shortHeader, shortDescription } = offer;

    const primaryLinkSlug = toSlug(primaryText);
    const secondaryLinkSlug = toSlug(secondaryText);

    const primaryLinkId = `${DOM_PRIMARY_LINK}_${primaryLinkSlug}`;
    const secondaryLinkId = `${DOM_SECONDARY_LINK}_${secondaryLinkSlug}`;

    const secondaryTrack = trackingLocation
      ? trackAnalyticsNew({
        url: makeAndOpenModal ? '' : secondaryLink,
        location: trackingLocation,
        name: secondaryTrackingName,
        tags: secondaryButtonTagSet,
      })
      : trackAnalytics(parentId, secondaryLinkId, secondaryLink, secondaryButtonTagSet);

    const trackPrimaryAnalytics = (redirectUrl) => {
      return trackingLocation
        ? trackAnalyticsNew({
          url: redirectUrl,
          location: trackingLocation,
          name: primaryTrackingName,
          tags: primaryButtonTagSet,
        })
        : trackAnalytics(parentId, primaryLinkId, redirectUrl, primaryButtonTagSet);
    };

    const primaryLabel = resolveAccessibleLabel(
      descriptiveText,
      shop,
      linkTextPrepositions,
      'at1',
      primaryText,
      shortHeader !== null ? shortHeader : shortDescription,
      prepositionKey !== null ? prepositionKey : 'and',
    );

    const secondaryLabel = Object.keys(offer).length === 0
      ? resolveAccessibleLabel(
        null,
        shop,
        linkTextPrepositions,
        'for',
        secondaryText
      )
      : resolveAccessibleLabel(
        offer.descriptiveText,
        shop,
        offer.linkTextPrepositions,
        'for',
        secondaryText,
        shortHeader !== null ? shortHeader : shortDescription,
        prepositionKey !== null ? prepositionKey : 'to'
      );
    const renderHoverState = (
      <HoverState>
        <ButtonsContainer>
          <PinterestAnalyticsTracker leadName={primaryText} shopSlug={shopSlug}>
            <ShopNowButton
              variant="secondary"
              size="small"
              shopSlug={shopSlug}
              offerSlug={offerSlug}
              locale={locale}
              trackAnalytics={trackPrimaryAnalytics}
              dataLayerId={dataLayerId}
              dataContextContainer={dataContextContainer}
              title={imageTitleTag}
              idPrefix={idPrefix}
              accessibleLabel={primaryLabel}
              buttonText={primaryText}
          />
          </PinterestAnalyticsTracker>
          <PinterestAnalyticsTracker leadName={secondaryText} shopSlug={shopSlug}>
            <Button
              variant="secondary"
              size="small"
              {...secondaryTrack}
              url={(
                !makeAndOpenModal
                  ? secondaryTrack.url
                  : undefined
              )}
              dataLayerId={dataLayerId}
              dataTrackType={DATA_TRACK_TYPE_CTA}
              dataContextContainer={dataContextContainer}
              onClick={makeAndOpenModal}
              idPrefix={idPrefix}
              accessibleLabel={secondaryLabel}
              buttonText={secondaryText}
            />
          </PinterestAnalyticsTracker>
        </ButtonsContainer>
      </HoverState>
    );

    return renderHoverState;
  }
}

export default CardHoverState;
